export default __webpack_public_path__ + "static/media/011-rhombus-purple.3d5a6e89.svg";